module.exports = __webpack_public_path__ + "static/img/gtm.3a3c88f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/gtm.svg
// module id = LBY8
// module chunks = 0